import { axios } from '@/utils/request'


export function getLoanList (parameter = {}) {
  return axios({
    url: '/batchPayments/query-payment',
    method: 'post',
    data: parameter
  })
}


export function getLimitData(parameter = {}) {
  return axios({
    url: '/batchPayments/pending-payment',
    method: 'get',
    params: parameter,
    responseType: 'blob' // 设置响应类型为blob
  })
}

export function importRecordPayment (parameter = {}) {
  return axios({
    url: '/batchPayments/import-record-payment',
    method: 'get',
    params: parameter,
    responseType: 'blob' // 设置响应类型为blob
  })
}


